import { useNavigate } from "react-router-dom";
import { Button } from "./Button";

const ConfirmMessageModal: React.FC<{
  message: string;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  submitFunction: () => void;
}> = ({ message, submitFunction, setMessage }) => {
  const navigate = useNavigate();

  const onClose = () => {
    setMessage("");
  }
  return (
    <div className="absolute flex justify-center items-center top-0 bottom-0 left-0 right-0">
      <div onClick={onClose} className="z-[6000] fixed right-0 left-0 top-0 bottom-0 bg-black opacity-[0.5]"></div>
      <div className="z-[6001] fixed">
        <div className="relative p-[25.2496px] mx-10 rounded-[12px] bg-white w-[calc(100vw-20vw)] max-w-[31.875rem]">
          <button
            onClick={onClose}
            className="absolute top-[25.2496px] right-[25.2496px] text-black hover:text-[#313131]"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>

          <div className="font-bold py-[25px] text-[#555555]">
            {message}
          </div>

          <div className="flex flex-row gap-[10px]">
            <Button
              variant="outline"
              type="submit"
              loading={false}
              onClick={onClose}
              className="w-full h-[50px]"
            >
              취소
            </Button>
            <Button
              type="submit"
              loading={false}
              onClick={submitFunction}
              className="w-full h-[50px]"
            >
              확인
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmMessageModal;
